import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { ParticleMorph } from "@/components/ParticleMorph";
import { JOURNEY_FULL } from "@/data/content";
import { useDeviceTier } from "@/hooks/useDeviceTier";
import { cn } from "@/lib/utils";

export const JourneyStrip = () => {
    const tier = useDeviceTier();

    return (
        <section id="idea-to-key" data-testid="idea-to-key-section" className="blueprint noise relative overflow-hidden py-24 lg:py-32">
            <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                {tier === "full" ? (
                    <ParticleMorph words={["IDEA", "FINAL KEY"]} className="mx-auto h-36 max-w-4xl sm:h-52" testid="particle-morph" />
                ) : (
                    <p className="text-center font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl" data-testid="particle-morph-static">
                        IDEA <span className="text-flame">→</span> FINAL KEY
                    </p>
                )}
                <SectionHeading
                    id="journey-strip-heading"
                    dark
                    align="center"
                    overline="From Idea to Final Key"
                    title={<>One continuous journey. <span className="text-flame">Every stage defined.</span></>}
                    description="Scroll through the exact stages every OMSIVO project moves through — nothing hidden, nothing vague."
                />
                <Reveal delay={0.15}>
                    <div className="mt-14 flex gap-3 overflow-x-auto pb-4 lg:grid lg:grid-cols-11 lg:overflow-visible"
                        data-lenis-prevent data-testid="journey-strip-rail">
                        {JOURNEY_FULL.map((s, i) => (
                            <div key={s.key}
                                className={cn(
                                    "relative flex min-w-[118px] snap-center flex-col items-center rounded-2xl border px-3 py-5 text-center lg:min-w-0",
                                    s.app ? "border-flame bg-omsivo-navy" : "border-white/10 bg-white/[0.04]"
                                )}
                                data-testid={`journey-full-${s.key.toLowerCase().replace(/\s+/g, "-")}`}>
                                <span className={cn("font-mono text-[9px]", s.app ? "text-flame" : "text-white/35")}>
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="mt-2 font-display text-[11px] font-extrabold uppercase leading-tight tracking-[0.08em] text-white">
                                    {s.key}
                                </span>
                                {s.app && (
                                    <span className="mt-2 rounded-full bg-flame px-2 py-0.5 font-mono text-[7px] font-bold uppercase tracking-[0.14em] text-white">
                                        OMSIVO App
                                    </span>
                                )}
                                {i < JOURNEY_FULL.length - 1 && (
                                    <ArrowRight className="absolute -right-3.5 top-1/2 z-10 hidden h-4 w-4 -translate-y-1/2 text-flame lg:block" />
                                )}
                            </div>
                        ))}
                    </div>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                        Detailed estimation runs on the OMSIVO Customer App — coming soon
                    </p>
                </Reveal>
            </div>
        </section>
    );
};
